export enum PlanTypes {
    individual = 'individual',
    institutional = 'institutional',
}
